<template>
    <div class="container">
        <headerPdf :bank="bank"></headerPdf>
        <contentPdf ></contentPdf>
        <footerPdf></footerPdf>
    </div>
</template>

<script>
import headerPdf from "@/components/defineSelfCourse/exportInfoInvoiceToPdf/headerPdf"
import contentPdf from "@/components/defineSelfCourse/exportInfoInvoiceToPdf/contentPdf"
import footerPdf from "@/components/defineSelfCourse/exportInfoInvoiceToPdf/footerPdf"
export default {
    props: {
        bank: Array
    },
    components: {
        headerPdf,
        contentPdf,
        footerPdf
    }
}
</script>



// WEBPACK FOOTER //
// src/components/defineSelfCourse/exportInfoInvoiceToPdf/exportToPdf.vue